import { AnchorElement } from '@thiememeulenhoff/lit-sdk';
import {
  ButtonSize,
  ButtonVariant,
  PropertyColor,
} from '@thiememeulenhoff/types';
import { customElement, property } from 'lit/decorators.js';
import { buttonStyles, tag } from './button.styles';

@customElement(tag)
export class ButtonComponent extends AnchorElement {
  static override styles = buttonStyles;

  @property({ type: Boolean, reflect: true })
  active = false;

  @property({ type: String, reflect: true })
  variant: ButtonVariant = 'default';

  @property({ type: String, reflect: true })
  color: PropertyColor = 'grey';

  @property({ type: String, reflect: true })
  size: ButtonSize = 'medium';

  @property({ type: Boolean, reflect: true })
  pill = false;

  @property({ type: Boolean, reflect: false })
  animation = false;

  @property({ type: String, reflect: false }) // reflect false to prevent container aria-label
  override ariaLabel = '';

  override render() {
    if (this.variant === 'dual') {
      throw Error(`Variant dual not supported for Buttons`);
    }
    return super.render();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-button': ButtonComponent;
  }
}
